import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Eye, MapPin, UserCheck, UsersRound } from 'lucide-react';
import Button from '../ui/Button';
import AnnouncementMemberService from '../../services/AnnouncementMemberService';

const ROLE_BADGES = [
    { key: 'admins', label: 'Admins', className: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-500/10 dark:text-purple-400 dark:border-purple-500/20' },
    { key: 'doctors', label: 'Doctors', className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-500/10 dark:text-green-400 dark:border-green-500/20' },
    { key: 'rsos', label: 'RSOs', className: 'bg-pink-50 text-pink-700 border-pink-200 dark:bg-pink-500/10 dark:text-pink-400 dark:border-pink-500/20' },
    { key: 'nurses', label: 'Nurses', className: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-500/10 dark:text-orange-400 dark:border-orange-500/20' },
];

function TeamCard({ setTeams, teams = [], announcementId, assigned = true, handelViewTeam, onAssignTeam, onAssigned }) {
    console.log('teams process', teams);
    const [activatingId, setActivatingId] = useState(null);

    const ActivateAll = async (teamId) => {
        if (activatingId) return;
        setActivatingId(teamId);
        try {
            const data = await AnnouncementMemberService.activateAll(announcementId, teamId);

            if (data.error) {
                toast.error('Something went wrong!');
                return;
            }
            // Wording stays status-agnostic on purpose — the server only sends the
            // actual push once the incident is Active; on a Pending incident this just
            // stages the roster ahead of command approval.
            toast.success('Team assigned to incident.');
            console.log('Team Activation Response', data);

            const filterTeams = teams.filter(({ id }) => teamId !== id);
            setTeams(filterTeams);
            if (onAssigned) onAssigned();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to notify team. Please retry.');
        } finally {
            setActivatingId(null);
        }
    };

    if (teams.length === 0) {
        return (
            <div className="strategy-card text-center text-sm text-neutral-400 py-10 space-y-4 dark:text-neutral-500">
                <p>No teams to display.</p>
                {assigned && onAssignTeam && (
                    <Button variant="primary" size="sm" icon={UsersRound} onClick={onAssignTeam}>
                        Assign Team
                    </Button>
                )}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {teams.map((item) => (
                <div key={item.id} className="strategy-card">
                    <div className="flex items-center justify-between gap-2 mb-4">
                        <h4 className="font-bold text-neutral-900 text-sm dark:text-neutral-50">{item?.name}</h4>
                        {typeof item.totalMembers === 'number' && (
                            <span className="badge badge-blue">{item.totalMembers} members</span>
                        )}
                    </div>

                    <div className="grid grid-cols-4 gap-2 mb-4">
                        {ROLE_BADGES.map((role) => (
                            <div key={role.key} className={`rounded-lg border text-center py-2 ${role.className}`}>
                                <p className="text-sm font-bold">{item[role.key] || 0}</p>
                                <p className="text-[10px] font-semibold uppercase tracking-wide">{role.label}</p>
                            </div>
                        ))}
                    </div>

                    <div className="flex gap-2">
                        <Button variant="secondary" size="sm" icon={Eye} className="flex-1" onClick={() => handelViewTeam(item.id)}>
                            View
                        </Button>
                        {!assigned && (
                            <Button variant="secondary" size="sm" icon={MapPin} className="flex-1">
                                Locate
                            </Button>
                        )}
                        {!assigned && (
                            <Button
                                variant="primary"
                                size="sm"
                                icon={UserCheck}
                                className="flex-1"
                                onClick={() => ActivateAll(item.id)}
                                disabled={!!activatingId}
                            >
                                {activatingId === item.id ? 'Assigning…' : 'Assign'}
                            </Button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TeamCard;
